import NavBar from "./NavBar";

function Panel({ children, panelRef, AsideRef }) {
    return (
        <div id="panel" className="shadow" ref={panelRef}>
            <NavBar AsideRef={AsideRef} />
            {children}
        </div>
    );
}

export default Panel;
